import { useEffect, useState } from 'react';
import { navItems } from '@/mocks/gossip';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? 'border-b border-background-200/80 bg-background-50/95 shadow-[0_1px_0_0] shadow-background-200/40 backdrop-blur-md'
          : 'border-b border-transparent bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 max-w-[1280px] items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-lg text-background-50">
            <i className="ri-quill-pen-fill" />
          </span>
          <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
            吃瓜最新
            <span className="font-label ml-1.5 align-middle text-[10px] font-semibold tracking-[0.2em] text-primary-600 uppercase">
              Melon Buzz
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.key}
              href={`#${item.key}`}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-2 lg:flex">
          <a
            href="#tougao"
            className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-4 py-2 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-accent-600"
          >
            <i className="ri-megaphone-line" />
            匿名投稿
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-900 lg:hidden"
        >
          <i className={`${open ? 'ri-close-line' : 'ri-menu-3-line'} text-2xl`} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pt-2 pb-4 lg:hidden">
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.key}
                href={`#${item.key}`}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-700 hover:bg-secondary-100"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="#tougao"
            onClick={() => setOpen(false)}
            className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-4 py-2 text-sm font-medium whitespace-nowrap text-background-50"
          >
            <i className="ri-megaphone-line" />
            匿名投稿
          </a>
        </div>
      )}
    </header>
  );
}